import { render } from "./FleetTable.vue?vue&type=template&id=63e10792&scoped=true"
import script from "./FleetTable.vue?vue&type=script&lang=js"
export * from "./FleetTable.vue?vue&type=script&lang=js"

import "./FleetTable.vue?vue&type=style&index=0&id=63e10792&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e10792"]])

export default __exports__